import React from 'react'
import { TableRow } from '@material-ui/core'
import DefaultTableCell from './DefaultTableCell'
import moment from 'moment'
import { getDaysInMonth, DaysInMonth } from '../utils/Helpers'

type Props = {
  title: string
}
export default function EmptyCells ({ title }: Props): JSX.Element {
  return (
    <TableRow>
      <DefaultTableCell>{title}</DefaultTableCell>
      {getDaysInMonth(moment().year(), moment().month() + 1).map((day: DaysInMonth) => {
        return <DefaultTableCell key={day.date} className={day.isWeekend ? 'weekend' : ''}>-</DefaultTableCell>
      })}
    </TableRow>
  )
}
